import type { ErrorBizLog } from '@shared/util/bi/error'
import type { BizLog, PageViewBizLog } from '@shared/util/bi/index'
import { ErrorBiLogger, PageViewBiLogger } from '@shared/util/bi/index'
import { parseBoolean } from '@shared/util/boolean'
import { ApiOptions, postRequest } from '.'
import { route } from '@/router'
import { getSchoolSymbol } from '@/router/util'

const CustomBiConfig = Object.freeze({
  Biz: import.meta.env.VITE_SITE_NAME,
  Apps: {
    Default: 'Default',
  },
  Enable: {
    PageView: parseBoolean(import.meta.env.VITE_LOG_ENABLE_PAGE_VIEW),
    Error: parseBoolean(import.meta.env.VITE_LOG_ENABLE_ERROR),
    Performance: parseBoolean(import.meta.env.VITE_LOG_ENABLE_PERFORMANCE),
  },
})
// nginx handle
const collectLog = (logs: BizLog[], group = 'default') => {
  return postRequest(
    new ApiOptions({
      url: `/frontEnd/collect/${group}`,
      args: logs,
      ignore403: true,
    }),
  ).catch(() => {})
}

class PaperWritingPageViewBiLogger extends PageViewBiLogger {
  send = (logs: BizLog[]) => (CustomBiConfig.Enable.PageView && collectLog(logs)) || Promise.resolve()
  override processLog = (log: PageViewBizLog) => {
    log.biz = CustomBiConfig.Biz
    log['school'] = getSchoolSymbol()
    return log
  }
}
class PaperWritingErrorBiLogger extends ErrorBiLogger {
  send = (logs: BizLog[]) => (CustomBiConfig.Enable.Error && collectLog(logs, 'error')) || Promise.resolve()
  override processLog = (log: ErrorBizLog) => {
    log.biz = CustomBiConfig.Biz
    log.pageName = route.value.name as string
    if (log.pageName === 'notFound') {
      return
    }
    return log
  }
}

const isProduction = import.meta.env.VITE_BUSINESS_ENV === 'prod'
const customPageViewBiLogger = new PaperWritingPageViewBiLogger()
const customErrorBiLogger = new PaperWritingErrorBiLogger({
  percent: isProduction ? 0.3 : 1,
  max: isProduction ? 15 : 1000,
})

export {
  CustomBiConfig, customErrorBiLogger, customPageViewBiLogger,
}
